import { Briefcase, Building2, User } from 'lucide-react'
import { Helmet } from 'react-helmet'
import { useLocation, useNavigate } from 'react-router'

import { SkeletonRows } from '@/components/ui/skeleton'
import { ToggleTabs } from '@/components/ui/ToggleTabs'
import { isOrgAdmin, useCurrentUser } from '../../../../models/user'
import { OrganisationTab } from './OrganisationTab'
import { StaffTab } from './StaffTab'
import { UserTab } from './UserTab'

const DEFAULT_TAB = 'user'

export function AdminSettings() {
  const { user, isLoading } = useCurrentUser({ enabled: true })
  const location = useLocation()
  const navigate = useNavigate()

  const currentTab = location.hash.slice(1) || DEFAULT_TAB

  function onTabChange(value: string) {
    void navigate(
      { search: location.search, hash: value === DEFAULT_TAB ? '' : value },
      { replace: true, preventScrollReset: true }
    )
  }

  function renderContent() {
    if (isLoading || !user) {
      return <SkeletonRows />
    }

    const org = user.currentOrg
    const orgUser = user.orgUser
    const showOrgTab = isOrgAdmin(user)
    const showStaffTab = user.isStaff

    return (
      <ToggleTabs
        value={currentTab}
        onValueChange={onTabChange}
        className="w-full"
        items={[
          { value: 'user', icon: <User />, label: 'User' },
          { value: 'organisation', icon: <Building2 />, label: 'Organization', hidden: !showOrgTab },
          { value: 'staff', icon: <Briefcase />, label: 'Staff', hidden: !showStaffTab },
        ]}
      >
        {currentTab === 'user' && <UserTab user={user} orgUser={orgUser} />}
        {showOrgTab && currentTab === 'organisation' && <OrganisationTab org={org} />}
        {showStaffTab && currentTab === 'staff' && <StaffTab user={user} />}
      </ToggleTabs>
    )
  }

  return (
    <>
      <Helmet>
        <title>Admin Settings</title>
      </Helmet>
      <div className="flex flex-col gap-5">
        <div className="mb-2 text-2xl font-semibold">Admin Settings</div>
        {renderContent()}
      </div>
    </>
  )
}
